import React from 'react'
import '../Common.scss';
import defaultImage from '../../../assets/default.png';


export default function FalseCeilingElectricalView({pageDetails}) {
  const {images,metaData}=pageDetails
  let electricalArrays = [];
  let electricalKeys= []
  if(metaData.falseCeilingElectricalData.length>0){
    electricalKeys=Object.keys(metaData.falseCeilingElectricalData[0])
    let metaDataElectrical= Array.from(metaData.falseCeilingElectricalData);
  
    let parts=metaData.falseCeilingElectricalData.length/5;
    
    for (let i = parts; i > 0; i--) {
      electricalArrays.push(metaDataElectrical.splice(0, Math.ceil(metaDataElectrical.length / i)));
    }
  }

  return (
    <React.Fragment>
    <div className="page-image-container">
        <div className="page-heading">{pageDetails?.name}</div>
        <div className="image-section-container">
            <img crossOrigin="anonymous" src={images ? images[0].imageUrl : defaultImage} alt="" className="image-view" />
        </div>
    </div>
    {electricalArrays.length>0 ? 
    <>
      <div className="details-heading-wrapper details-heading">
        ELECTRICAL SPECIFICATIONS
      </div>
      <div className="details">
      {electricalArrays.map((lightsArray,index1)=>{
      return <div className="details-table"  style={{marginRight:"150px"}}  key={index1}>
              <React.Fragment>
                  <div className="table-row" style={{width:"800px"}}>
                      {
                        electricalKeys.map((heading,index2)=>{
                            return <div className="table-cell color-heading" key={index2} style={{width:'20%'}}>
                                {heading.toString().toUpperCase()}
                            </div>
                        })
                      }
                  </div>
              </React.Fragment> 
              {lightsArray.map((arrObj, index) => {
                return (
                    <React.Fragment key={index}>
                        {
                          <div className="table-row" style={{width:"800px",marginRight:"10px"}}>
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj?.caption}
                              </div>
                              <div className="table-cell" style={{width:"20%"}}>
                                 {arrObj?.description?.toUpperCase()}
                              </div>
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj?.moduleType?arrObj?.moduleType:"NA"}
                              </div>
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj?.socketType ? arrObj?.socketType : "NA"}
                              </div>   
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj?.serviceMapping? arrObj?.serviceMapping : "NA"}
                              </div>
                              <div className="table-cell" style={{width:"20%"}}>
                                  {arrObj?.pointType ? arrObj?.pointType : "NA"}
                              </div>
                          </div>
                        }
                    </React.Fragment>
                );
            })}
          </div>
        })}
        </div>
    </> : null}
    </React.Fragment>
  )
}
